import { ERiskLevel } from '../subcomponents/score-dashboard/subcomponents/score-result/types';

export interface IScoreBand {
  de: number;
  ate: number;
  probability: number | null;
  riskLevel: ERiskLevel | null;
  /** Valor exibido no texto da faixa (PF: % que paga; PJ: quantidade a cada 1000). Null quando indisponível. */
  descriptionValue: number | null;
  /** Chave i18n do texto, usada apenas nas faixas indisponíveis (ex.: 'unavailable.noRelevantInfo'). */
  textKey: string | null;
}

const band = (de: number, ate: number, probability: number, riskLevel: ERiskLevel, descriptionValue: number): IScoreBand => ({
  de,
  ate,
  probability,
  riskLevel,
  descriptionValue,
  textKey: null,
});

const unavailableBand = (de: number, ate: number, textKey: string): IScoreBand => ({
  de,
  ate,
  probability: null,
  riskLevel: null,
  descriptionValue: null,
  textKey,
});

const SCORE_UNAVAILABLE_BAND = unavailableBand(Number.NaN, Number.NaN, 'unavailable.scoreUnavailable');

const PF_SCORE_BANDS: IScoreBand[] = [
  band(940, 1000, 0.2, ERiskLevel.LOW, 99.8),
  band(880, 939, 0.3, ERiskLevel.LOW, 99.7),
  band(820, 879, 0.5, ERiskLevel.LOW, 99.5),
  band(760, 819, 0.8, ERiskLevel.LOW, 99.2),
  band(700, 759, 1, ERiskLevel.LOW, 99),
  band(640, 699, 2, ERiskLevel.LOW, 98),
  band(580, 639, 3, ERiskLevel.LOW, 97),
  band(520, 579, 4, ERiskLevel.LOW, 96),
  band(460, 519, 6, ERiskLevel.LOW, 94),
  band(400, 459, 9, ERiskLevel.LOW, 91),
  band(340, 399, 13, ERiskLevel.MEDIUM, 87),
  band(280, 339, 18, ERiskLevel.MEDIUM, 82),
  band(220, 279, 25, ERiskLevel.MEDIUM, 75),
  band(160, 219, 34, ERiskLevel.MEDIUM, 66),
  band(2, 159, 52, ERiskLevel.HIGH, 48),
  unavailableBand(1, 1, 'unavailable.noRelevantInfo'),
];

const PJ_SCORE_BANDS: IScoreBand[] = [
  band(940, 1000, 0.1, ERiskLevel.LOW, 1),
  band(880, 939, 0.2, ERiskLevel.LOW, 2),
  band(820, 879, 0.4, ERiskLevel.LOW, 4),
  band(760, 819, 0.7, ERiskLevel.LOW, 7),
  band(700, 759, 1.3, ERiskLevel.LOW, 13),
  band(640, 699, 2.3, ERiskLevel.LOW, 23),
  band(580, 639, 4.1, ERiskLevel.LOW, 41),
  band(520, 579, 7.1, ERiskLevel.LOW, 71),
  band(460, 519, 12.2, ERiskLevel.MEDIUM, 122),
  band(400, 459, 20.1, ERiskLevel.MEDIUM, 201),
  band(340, 399, 31.2, ERiskLevel.MEDIUM, 312),
  band(280, 339, 45, ERiskLevel.MEDIUM, 450),
  band(220, 279, 59.6, ERiskLevel.HIGH, 596),
  band(160, 219, 72.7, ERiskLevel.HIGH, 727),
  band(3, 159, 88, ERiskLevel.HIGH, 880),
  unavailableBand(2, 2, 'unavailable.notClassified'),
  unavailableBand(1, 1, 'unavailable.noRelevantInfo'),
];

export function resolveScoreBand(isCompany: boolean, score?: number | null): IScoreBand {
  if (score === null || score === undefined || Number.isNaN(score)) {
    return SCORE_UNAVAILABLE_BAND;
  }

  const bands = isCompany ? PJ_SCORE_BANDS : PF_SCORE_BANDS;
  return bands.find(item => score >= item.de && score <= item.ate) ?? SCORE_UNAVAILABLE_BAND;
}
